import React from 'react';
import InformationBlock from '../../../../../@casino/ui/informationBlock';
import { useStyles } from './helpers';

const TwoRow = ({ users }) => {
    const classes = useStyles();

    const timeFormat = (function () {
        function num(val) {
            val = Math.floor(val);
            return val < 10 ? '0' + val : val;
        }

        return function (ms/**number*/) {
            const sec = ms / 1000
                , minutes = sec / 60 % 60
                , seconds = sec % 60
                ;

            return num(minutes) + ":" + num(seconds);
        };
    })();

    return (
        <div style={{height: 230, width: '50%'}}>
            <InformationBlock
                label="ОНЛАЙН ПОЛЬЗОВАТЕЛИ"
                width="100%"
                lineColor="#3cde0b">
                <div style={{ padding: 10 }}>
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '5px 10px' }}>
                        <div style={{ width: '33%', display: 'flex', justifyContent: 'center' }}>
                            <span>ID</span>
                        </div>
                        <div style={{ width: '33%', display: 'flex', justifyContent: 'center' }}>
                            <span>Логин</span>
                        </div>
                        <div style={{ width: '33%', display: 'flex', justifyContent: 'center' }}>
                            <span>Последнее действие</span>
                        </div>
                    </div>
                    <div style={{overflowY: 'scroll', maxHeight: 150}}>
                        {
                            users?.map((item, key) => {
                                const date = new Date().getTime() - item?.online;
                                return (
                                    <div style={{ display: 'flex', justifyContent: 'center', padding: '5px 10px', borderTop: '1px solid rgba(255,255,255,.1)' }}>
                                        <div style={{ width: '33%', display: 'flex', justifyContent: 'center' }}>
                                            <span>{item.id}</span>
                                        </div>
                                        <div style={{ width: '33%', display: 'flex', justifyContent: 'center' }}>
                                            <span>{item.login}</span>
                                        </div>
                                        <div style={{ width: '33%', display: 'flex', justifyContent: 'center' }}>
                                            <span >{timeFormat(date)}</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </InformationBlock>
        </div>
    )
}

export default TwoRow;